import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftNWSVolumeServer } from "namirasoft-nws-volume";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { NWSVolumeLayout } from "./NWSVolumeLayout";
import { NWSVolumeRoutes } from "./NWSVolumeRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import VolumeEditPage from "./pages/VolumeEditPage";
import VolumeListPage from "./pages/VolumeListPage";
import VolumeViewPage from "./pages/VolumeViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_NWS_VOLUME}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_NWS_VOLUME = new EnvService("REACT_APP_BASE_URL_NWS_VOLUME", true).getString();

            let nws_volume = new NamirasoftNWSVolumeServer(REACT_APP_BASE_URL_NWS_VOLUME, result.account.token_manager, result.notifier.onError);

            let servers = { nws_volume };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={NWSVolumeRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={NWSVolumeRoutes.VolumeList} element={<VolumeListPage {...result} servers={servers} />} />
                            <Route path={NWSVolumeRoutes.VolumeNew} element={<VolumeEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={NWSVolumeRoutes.VolumeView(":id")} element={<VolumeViewPage {...result} servers={servers} />} />
                            <Route path={NWSVolumeRoutes.VolumeEdit(":id")} element={<VolumeEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={NWSVolumeRoutes.VolumeCopy(":id")} element={<VolumeEditPage {...result} servers={servers} isEdit={true} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={NWSVolumeRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <NWSVolumeLayout {...props}>
                {props.children}
            </NWSVolumeLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: true
            }
        }}
    />
}

export default Router;